import { createContext } from 'react'

import type { BlockContentVariant, BlockLayoutVariant, BlockSize } from './types'

/**
 * Context to transmit the variant and settings to sub-components
 * Supports variant override when blocks are nested (composition)
 */
export type BlockContextValue = {
  /** Block size - controls spacing and typography */
  size: BlockSize
  /** Layout variant - controls spacing between items */
  layoutVariant: BlockLayoutVariant
  /** If true, multiple collapsible blocks can be open simultaneously */
  allowMultiple: boolean
  /** Depth level for nested blocks - used to preserve variant when composing blocks */
  depth: number
  /** Content variant for nested blocks - flips between 'soft' and 'accent' at each level */
  contentVariant: BlockContentVariant
  disabled?: boolean
}

export const BlockContext = createContext<BlockContextValue>({
  size: 'md',
  layoutVariant: 'separated',
  allowMultiple: false,
  depth: -1,
  disabled: false,
  contentVariant: 'accent',
})
